import React from 'react';
import clsx from 'clsx';
import Drawer from '@material-ui/core/Drawer';
import List from '@material-ui/core/List';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
// import InboxIcon from '@material-ui/icons/MoveToInbox';
import IconLabelItem from '../../molecules/iconLabelItem';
import { Link, withRouter } from 'react-router-dom';
import ExpandCollapseBtn from '../ExpandCollapse';
import './miniDrawer.css'
import useStyles from './style';
import { connect } from 'react-redux';
import { openDrawer, closeDrawer } from '../../../redux/actions/drawer'

function MiniDrawer(props) {
    const classes = useStyles();

    const getLinkItem = ({ menu, isSubMenu, selectedLink }) => {//creating drawer option and adding link for route
        const { label, linkTo } = menu;
        let isSelected = selectedLink === linkTo;
        let firstLevelMenu =
            <IconLabelItem
                icon={menu.class}
                iconClass={clsx(menu.class, { 'selected': isSelected })}
                label={label}
                listItemClass={clsx(classes.drawerOption,
                    { [classes.drawerOptionSelected]: isSelected },
                    { [classes.nested]: isSubMenu }
                )}
            />
        return (
            <Link onClick={() => props.handleDrawerOption(label)} key={linkTo} to={`${props.path}${linkTo}`}>
                {firstLevelMenu}
            </Link>
        )
    }

    const isLinkSelected = (link) => {
        let isSelected = props.location.pathname.indexOf(`${props.path}${link}`) > -1;
        return isSelected;
    }

    const getActiveMenuLink = () => {
        let matchedLinks = []
        props.drawerOptions.forEach(({ menu, subMenu }, index) => {
            if (!subMenu) {
                const { linkTo } = menu;
                if (isLinkSelected(linkTo)) {
                    matchedLinks.push(linkTo)
                }
            } else {
                subMenu.forEach(({ menu }) => {
                    const { linkTo } = menu;
                    if (isLinkSelected(linkTo)) {
                        matchedLinks.push(linkTo)
                    }
                })
            }
        })
        let selectedLink = '';
        matchedLinks.forEach(link => {
            if (link.length > selectedLink.length) {
                selectedLink = link;
            }
        })
        return selectedLink;
    }

    const getDrawerList = () => {//creating drawer list from props.drawerOptions
        let selectedLink = getActiveMenuLink();
        return props.drawerOptions.map(({ menu, subMenu }, index) => {
            const { label } = menu;
            if (!subMenu) {
                return getLinkItem({ menu, selectedLink })//firstLenvel Menu
            } else {
                return (//subMenu
                    <ExpandCollapseBtn
                        key={label}
                        icon={menu.class}
                        iconClass={menu.class}
                        label={label}
                        listItemClass={classes.drawerOption}
                        collapse={!props.isDrawerOpen}//when drawer closes, collapse sub Menu
                    >
                        <List>
                            {subMenu.map(({ menu }) => {
                                return getLinkItem({ menu, isSubMenu: true, selectedLink })
                            })}
                        </List>
                    </ExpandCollapseBtn >
                )
            }
        })
    }

    const handleDrawerOpen = () => {
        props.openDrawer();
    };

    const handleDrawerClose = () => {
        props.closeDrawer();
    };

    return (
        <>
            <div className={classes.drawerContentContainer}>
                <Drawer variant="permanent"
                    className={clsx(classes.drawer, {
                        [classes.drawerOpen]: props.isDrawerOpen,
                        [classes.drawerClose]: !props.isDrawerOpen,
                    })}
                >
                    {
                        <div className={clsx(classes.arrow, {
                            [classes.arrowOpen]: props.isDrawerOpen,
                            [classes.arrowClose]: !props.isDrawerOpen,
                        })}
                            onClick={props.isDrawerOpen ? handleDrawerClose : handleDrawerOpen}>
                            {props.isDrawerOpen ? <ChevronLeftIcon className={'left-arrow'} /> : <ChevronRightIcon className={'right-arrow'} />}
                        </div>
                    }
                    <List>
                        {getDrawerList()}
                    </List>
                </Drawer>
            </div>
        </>
    );
}

const mapDispatchToProps = (dispatch) => ({
    openDrawer: () => dispatch(openDrawer()),
    closeDrawer: () => dispatch(closeDrawer()),
})

export default withRouter(connect(null, mapDispatchToProps)(MiniDrawer));